// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__vMI_3","validationTips":"StatementDescriptor_validationTips__36QF9"};